import { EntityInterface } from '../entity/interfaces/entityInterface.model';

export class AppTableEvent {

    public static readonly EVENT_CLICK = 'click';
    public static readonly EVENT_DBLCLICK = 'dblclick';
    public static readonly EVENT_ENTER = 'enter';
    public static readonly EVENT_REMOVE = 'APP-REMOVE';
    public static readonly EVENT_EDIT = 'APP-EDIT';
    public static readonly EVENT_COLLAPSE = 'APPCOLLAPSE';
    public static readonly EVENT_EXPAND = 'APPSPAND';

    public event: string;
    public rowIndex: number;
    public colIndex: number;
    public entity: EntityInterface;
    public multipleSelected: boolean;

    constructor() {
    }
}
